import { gsap } from 'gsap';
import { randomFloat } from './random';

export class AirbrushEffect {
  constructor(container, numParticles = 10) {
    this.container = container;
    this.numParticles = numParticles;
    this.particles = [];
    this.tweens = [];
    this.running = false;
  }

  _createParticle() {
    const div = document.createElement('div');
    Object.assign(div.style, {
      position: 'absolute',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      opacity: '0',
      pointerEvents: 'none',
    });
    this.container.appendChild(div);
    return div;
  }

  _randomizePosition(el) {
    const maxX = 80;
    const maxY = 80;
    const x = Math.random() * maxX;
    const y = Math.random() * maxY;
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
  }

  _animateParticle(el) {
    if (!this.running) return;

    this._randomizePosition(el);
    const scale = randomFloat(0.8, 1);

    gsap.set(el, { opacity: 0, scale: scale });

    const tween = gsap
      .timeline({ repeat: -1 })
      .to(el, { opacity: 1, duration: 0.1, ease: 'none' })
      .to(el, {
        opacity: 0,
        scale: randomFloat(0.3, scale - 0.2),
        duration: randomFloat(0.2, 0.7),
        delay: randomFloat(0, 0.5),
        ease: 'power3.out',
        onRepeat: () => {},
        onComplete: () => {
          if (!this.running) tween.kill();
          this._randomizePosition(el);
        },
      });

    this.tweens.push(tween);
  }

  start() {
    if (this.running) return;
    this.running = true;

    if (!this.particles.length) {
      for (let i = 0; i < this.numParticles; i++) {
        const el = this._createParticle();
        this.particles.push(el);
        this._animateParticle(el);
      }
    } else {
      for (const tween of this.tweens) tween.kill();
      this.tweens = [];
      for (const el of this.particles) this._animateParticle(el);
    }
  }

  stop() {
    this.running = false;
  }
}
